import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../interfaces/orders/order';

@Component({
    selector: 'lib-ubo-financial-risk-questions',
    templateUrl: './ubo-financial-risk-questions.component.html',
    styleUrls: [
        './ubo-financial-risk-questions.component.css',
        './../../../results-page.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UboFinancialRiskQuestionsComponent {
  @Input() public order!: Order;

  constructor() {}
}